/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { AppState } from "Dataflows/Reducers";

import {
  IProgramLanguageData,
  IProgramLanguageDataState,
  IProgramLanguageOptionList,
} from "../../Interfaces/SiteContent";

/**
 * program language data selector.
 */
export const getProgramLanguages = (state: IProgramLanguageDataState): IProgramLanguageData[] =>
  state.programLanguages;

/**
 * program language option list data selector.
 */
export const getProgramLanguageOptionList = (
  state: IProgramLanguageDataState
): IProgramLanguageOptionList[] => state.programLanguageOptionList;

export const getAppStateProgramLanguageOptionList = (
  state: AppState
): IProgramLanguageOptionList[] => state.programLanguageDataState.programLanguageOptionList;

/**
 * program language data load error selector.
 */
export const getProgramLanguageLoadError = (state: IProgramLanguageDataState): string =>
  state.programLanguageLoadError;

export const getAppStateProgramLanguageLoadError = (state: AppState): string =>
  state.programLanguageDataState.programLanguageLoadError;
